<template>
  <div style="min-height: 100vh; display: flex">
    <v-row align="center" justify="center" no-gutters>
      <v-card flat width="90%" max-width="400px" class="pa-4 elevation-8">
        <v-card-title>Фортуна-Логистика</v-card-title>
        <v-divider />
        <v-form @submit.prevent="okClick">
          <v-col cols="12 px-0">
            <v-text-field v-model="authenticationCode" type="text" label="Код" :placeholder="!autofilled ? ' ' : ''"
              required>
              <template v-slot:prepend>
                <v-icon>mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-card-actions class="px-0">
            <v-spacer />
            <v-btn type="submit" class="px-8" color="primary" :loading="submiting" @click.prevent="okClick">
              Войти
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
  </div>
</template>

<script>

export default {
  data: () => ({
    login: '',
    password: '',
    authenticationCode: '',
    authCodeVisible: false,
    isAuthCodeInputFieldVisible: false,
    isAuthCodeGettingEnabled: true,
    submiting: false,
    autofilled: false,
    from: null
  }),

  methods: {
    okClick() {
      if (!this.authenticationCode) {
        this.$notify('error', 'Пожалуйста, введите код аутентификации');
        return;
      }

      this.submiting = true;
      this.login = localStorage.getItem('login');
      this.password = localStorage.getItem('password');

      this.$store.dispatch('auth/validateAuthToken', {
        login: this.login,
        password: this.password,
        authCode: this.authenticationCode
      })
        .then(response => {
          // Set the token in store
          this.$store.state.auth.token = response?.token;
          localStorage.setItem('token', this.$store.state.auth.token)

          // OR if you have a setToken action:
          // return this.$store.dispatch('auth/setToken', token);

          // Then get user data
          return this.$store.dispatch('auth/setUser');
        })
        .then(() => {
          // Clean up temporary storage
          localStorage.removeItem('login');
          localStorage.removeItem('password');

          // Redirect to carQueue
          this.$router.push('/carQueue');
        })
        .catch(err => {
          this.$notify('error', 'Ошибка при проверке кода аутентификации');
        })
        .finally(() => {
          this.submiting = false;
        });
    }
  }
}
</script>